// import React, { Fragment, useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { Button } from "bootstrap";

// const AdList = () =>{
//     const { pubId, } = useParams(); // Get publisher ID from URL
//     const navigate = useNavigate();
//     const [adList, setAdList] = useState("");
//     const [loading, setLoading] = useState(true);
//     const [message, setMessage] = useState("");
//     const [filterStatus, setFilterStatus] = useState("all");

//     const alladList = async () =>{
//       try {
//             const token = localStorage.getItem("token");
//             const allAdsListRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/getAllAdPlacements/${pubId}`, {
//                     headers : {
//                         Authorization: `Bearer ${token}`,
//                         "Content-Type": "application/json",
//                         Accept: "application/json",
//                     },
//                 }
//               );
//                 console.log(allAdsListRes);
//                 if(allAdsListRes.status === 200){
//                   setAdList(allAdsListRes?.data?.data);
//                 }else {
//                   setMessage("No domains found.");
//                 }
//         } catch (error) {
//           if (error.status === 401) {
//             console.error("Unauthorized! Token might be expired.");
//             localStorage.removeItem("token");
//             navigate("/admin");
//           } else {
//             console.error("Error fetching data:", error);
//           }
//           setMessage("Error fetching Ad list.");
//         } finally {
//             setLoading(false);
//           }        
//     } 
//     const filteredAdList = adList?.length > 0
//          ? adList.filter((ad) => {
//           if (filterStatus === "all") return true;
//           const statusLabel = ad.status === 0 ? "Active" : ad.status === 1 ? "Inactive" : ad.status;
//           return statusLabel === filterStatus;
//              })
//             : [];
//  const handleGenerateJson = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/generateJs/${pubId}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//         },
//       });
//       console.log(response.status);
//       if (response.status === 200) {
//        alert("File uploaded successfully");
//       } else {
//         alert("Failed to generate JSON");
//         // setGenerateMessage(`Error: ${response.data.message || 'Failed to generate JSON.'}`);
//       }
//     } catch (error) {
//       console.error('Error generating JSON:', error);
//       const errorMsg = error.response?.data?.message || 'Failed to generate JSON.';
//       // setGenerateMessage(`Error: ${errorMsg}`);
//     }
//   };
//   // Bundle JS
//    const handleGenerateBundleJS = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/generateJs/${pubId}?isBundled=1`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//         },
//       });
//       console.log(response.status);
//       if (response.status === 200) {
//        alert("File uploaded successfully");
//       } else {
//         alert("Failed to generate Bundle JS");
//         // setGenerateMessage(`Error: ${response.data.message || 'Failed to generate JSON.'}`);
//       }
//     } catch (error) {
//       alert(error.response?.data?.message + "Error");
//       console.error('Error generating Bundle JS:', error);
//       const errorMsg = error.response?.data?.message || 'Failed to generate Bundle JS.';
//       // setGenerateMessage(`Error: ${errorMsg}`);
//     }
//   };
  
//     useEffect(() => {
//         alladList();
//   }, [pubId]);

//   return (
//     <section className="mainContainer">
//       <div className="container mt-4">
//         <h2>Ad List</h2>
//         {message && <div className="alert alert-info">{message}</div>}
//         <div className="wrapper" style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
//           <div className="buttonWrapper">
//         <button
//           className="btn btn-success mb-3"
//           onClick={() => navigate(`/create-ad/${pubId}`)}
//         >
//           + Create Ad Placement
//         </button>
//         <button
//           className="btn btn-warning mb-3 mx-3"
//           onClick={() => navigate(`/other-setting/${pubId}`)}
//         >
//           + Create Powered by Settings
//         </button>

//         <button
//           className="btn btn-primary mb-3"
//           onClick={() => {
//             if (window.confirm("Do you want to generate JSON?")) {
//               handleGenerateJson();
//             }
//           }}
//         >
//           Generate JSON
//         </button>

//         <button
//           className="btn btn-secondary mb-3 mx-3"
//           onClick={() => {
//             if (window.confirm("Do you want to generate Bundle JS?")) {
//               handleGenerateBundleJS();
//             }
//           }}
//         >
//           Generate Bundle JS
//         </button>
//         </div>
//         <div className="mb-3">
//             <label htmlFor="statusFilter" className="form-label">Filter by Ad Status: </label>
//             <select
//               id="statusFilter"
//               className="form-select"
//               style={{ width: "200px" }}
//               value={filterStatus}
//               onChange={(e) => setFilterStatus(e.target.value)}
//             >
//               <option value="all">All</option>
//               <option value="Active">Active</option>
//               <option value="Inactive">Inactive</option>
//             </select>
//         </div>
//       </div>
//       <div className="report-table-wrapper">
//       <div className="table-responsive adminReport">
//       <table className="table table-striped table-hover table-bordered">
//                 <thead>
//             <tr>
//               <th scope="col">S.N </th>
//               <th scope="col">PID Unit</th>
//               <th scope="col">Domain</th>
//               <th scope="col">Ad Unit</th>
//               <th scope="col">Ad Display Name</th>
//               <th scope="col">Ad Format</th>
//               <th scope="col">Device</th>
//               <th scope="col">Slot Size</th>
//               <th scope="col">Platform</th>
//               <th scope="col">Visible on Report</th>
//               <th scope="col">Ad Status</th>
//               <th scope="col"></th>
//             </tr>
//           </thead>
//           <tbody>
//             {
//               filteredAdList?.length > 0 ? (
//                 filteredAdList.map((adlists, adListsInd) =>(
//                   <tr key={adListsInd}>
//                     <td>{adListsInd + 1}</td>
//                     <td>{adlists.pid}</td>
//                     <td>{adlists.domain}</td>
//                     <td>{adlists.adunit_name}</td>
//                     <td>{adlists.ad_display_name}</td>
//                     <td>{adlists.design_format === "" || null ? "Banner" : adlists.design_format}</td>
//                     <td>{adlists.device}</td>
//                     <td>{adlists.slot_size}</td>
//                     <td>{adlists.platform_type}</td>
//                     <td>{adlists.is_visible === 0 ? "Yes" : adlists.is_visible === 1 ? "No" : adlists.is_visible}</td>
//                     <td>{adlists.status === 0 ? "Active" : adlists.status === 1 ? "Inactive" : adlists.status}</td>
//                     {/* <td>{adlists.is_visible}</td> */}
//                     <td>
//                     <button
//                       className="btn btn-warning btn-sm"
//                       onClick={() => navigate(`/update-ad/${adlists.account_id}/${adlists.pid}`)}
//                       >
//                       Edit
//                     </button>
//                     </td>
//                   </tr>
//                 ))
//               ) : 
//               <tr>
//                 <td colSpan="12" className="text-center">No data available</td>
//               </tr>
//             }
//             {/* <tr>
//                 <td>
//                     1.
//                 </td>
//                 <td>
//                     ACX-12345678
//                 </td>
//                 <td>
//                     abc.com
//                 </td>
//                 <td> <button
//                       className="btn btn-primary btn-sm"
//                       onClick={() => navigate(`/edit-ad/${domainList.account_id}`)}
//                       >
//                       Edit Ad Placement
//                     </button></td>
//             </tr> */}
//           </tbody>
//       </table>
//       </div>
//       </div>
//       </div>
//     </section>
//   )
// }

// export default AdList;

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./addList.css";

const AdList = () => {
  const { pubId } = useParams();
  const navigate = useNavigate();

  const [adList, setAdList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");

  // ==============================
  // Get Ad List
  // ==============================
  const alladList = async () => {
    try {
      const token = localStorage.getItem("token");

      const allAdsListRes = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/getAllAdPlacements/${pubId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (allAdsListRes.status === 200) {
        setAdList(allAdsListRes?.data?.data || []);
      } else {
        setMessage("No ads found.");
      }
    } catch (error) {
      if (error.response?.status === 401) {
        console.error("Unauthorized! Token might be expired.");
        localStorage.removeItem("token");
        navigate("/admin");
      } else {
        console.error("Error fetching data:", error);
      }

      setMessage("Error fetching Ad list.");
    } finally {
      setLoading(false);
    }
  };

  // ==============================
  // Filter
  // ==============================
  const filteredAdList =
    adList?.length > 0
      ? adList.filter((ad) => {
          if (filterStatus === "all") return true;

          const statusLabel =
            ad.status === 0
              ? "Active"
              : ad.status === 1
              ? "Inactive"
              : ad.status;

          return statusLabel === filterStatus;
        })
      : [];

  // ==============================
  // Generate JSON
  // ==============================
  const handleGenerateJson = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/generateJs/${pubId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      if (response.status === 200) {
        alert("File uploaded successfully");
      } else {
        alert("Failed to generate JSON");
      }
    } catch (error) {
      console.error("Error generating JSON:", error);
      alert(
        error.response?.data?.message || "Failed to generate JSON."
      );
    }
  };

  // ==============================
  // Generate Bundle JS
  // ==============================
  const handleGenerateBundleJS = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/generateJs/${pubId}?isBundled=1`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      if (response.status === 200) {
        alert("File uploaded successfully");
      } else {
        alert("Failed to generate Bundle JS");
      }
    } catch (error) {
      console.error("Error generating Bundle JS:", error);

      alert(
        error.response?.data?.message || "Failed to generate Bundle JS."
      );
    }
  };

  useEffect(() => {
    alladList();
  }, [pubId]);

  return (
    <section className="ad-list-page">
      <div className="ad-list-container">

        {/* ==========================
            HEADER
        =========================== */}
        <div className="ad-list-header">
          <div>
            <h2 className="ad-list-title">Ad List</h2>
            <p className="ad-list-subtitle">
              Manage ad placements and publisher settings
            </p>
          </div>
        </div>

        {message && (
          <div className="alert alert-info ad-list-alert">
            {message}
          </div>
        )}

        {/* ==========================
            ACTIONS + FILTER
        =========================== */}
        <div className="ad-list-toolbar">

          <div className="ad-list-actions">

            <button
              className="ad-action-btn ad-action-success"
              onClick={() => navigate(`/create-ad/${pubId}`)}
            >
              <span>+</span>
              Create Ad Placement
            </button>

            <button
              className="ad-action-btn ad-action-warning"
              onClick={() => navigate(`/other-setting/${pubId}`)}
            >
              <span>+</span>
              Create Powered by Settings
            </button>

            <button
              className="ad-action-btn ad-action-primary"
              onClick={() => {
                if (window.confirm("Do you want to generate JSON?")) {
                  handleGenerateJson();
                }
              }}
            >
              Generate JSON
            </button>

            <button
              className="ad-action-btn ad-action-secondary"
              onClick={() => {
                if (
                  window.confirm(
                    "Do you want to generate Bundle JS?"
                  )
                ) {
                  handleGenerateBundleJS();
                }
              }}
            >
              Generate Bundle JS
            </button>

          </div>

          {/* Filter */}
          <div className="ad-status-filter">
            <label htmlFor="statusFilter">
              Filter by Ad Status
            </label>

            <select
              id="statusFilter"
              className="ad-status-select"
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
            >
              <option value="all">All</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>

        </div>

        {/* ==========================
            TABLE
        =========================== */}
        <div className="ad-table-card">

          <div className="ad-table-scroll">

            <table className="ad-list-table">

              <thead>
                <tr>
                  <th>S.N</th>
                  <th>PID Unit</th>
                  <th>Domain</th>
                  <th>Ad Unit</th>
                  <th>Ad Display Name</th>
                  <th>Ad Format</th>
                  <th>Device</th>
                  <th>Slot Size</th>
                  <th>Platform</th>
                  <th>Visible on Report</th>
                  <th>Ad Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="12" className="ad-empty-state">
                      Loading ads...
                    </td>
                  </tr>
                ) : filteredAdList?.length > 0 ? (
                  filteredAdList.map((adlists, adListsInd) => (
                    <tr key={adListsInd}>

                      <td className="sn-column">
                        {adListsInd + 1}
                      </td>

                      <td>
                        <span className="pid-text">
                          {adlists.pid}
                        </span>
                      </td>

                      <td>
                        <span className="domain-text">
                          {adlists.domain}
                        </span>
                      </td>

                      <td>
                        {adlists.adunit_name}
                      </td>

                      <td>
                        {adlists.ad_display_name}
                      </td>

                      <td>
                        {adlists.design_format === "" ||
                        adlists.design_format == null
                          ? "Banner"
                          : adlists.design_format}
                      </td>

                      <td>
                        {adlists.device}
                      </td>

                      <td>
                        {adlists.slot_size}
                      </td>

                      <td>
                        {adlists.platform_type}
                      </td>

                      <td>
                        <span
                          className={`status-badge ${
                            adlists.is_visible === 0
                              ? "status-visible"
                              : "status-hidden"
                          }`}
                        >
                          {adlists.is_visible === 0
                            ? "Yes"
                            : adlists.is_visible === 1
                            ? "No"
                            : adlists.is_visible}
                        </span>
                      </td>

                      <td>
                        <span
                          className={`status-badge ${
                            adlists.status === 0
                              ? "status-active"
                              : "status-inactive"
                          }`}
                        >
                          {adlists.status === 0
                            ? "Active"
                            : adlists.status === 1
                            ? "Inactive"
                            : adlists.status}
                        </span>
                      </td>

                      <td className="action-column">
                        <button
                          className="ad-edit-btn"
                          onClick={() =>
                            navigate(
                              `/update-ad/${adlists.account_id}/${adlists.pid}`
                            )
                          }
                        >
                          Edit
                        </button>
                      </td>

                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="12"
                      className="ad-empty-state"
                    >
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>

            </table>

          </div>

        </div>

      </div>
    </section>
  );
};

export default AdList;